import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { palette } from '@m12s/component-library';
import { farSyncAlt } from 'lib/icons';
import { useSelector } from 'react-redux';
import { getSelectWorkOrderOpOptions } from 'lib/selectors/getSelectWorkOrderOp';
import { SpinningIcon } from '../styled';

const DefaultJobCardTitle = styled.h5`
  color: ${({ disabled }) => {
    return disabled ? palette.Grey500 : palette.Grey700;
  }};
  margin: 0;
`;

const StandardJobCardTitle = styled(DefaultJobCardTitle)`
  font-weight: 600;
  font-size: 1.5rem;
`;

const SearchJobCardTitle = styled(DefaultJobCardTitle)`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1rem;
`;

const JobCardSubTitle = styled.h6`
  margin: 0;
  color: ${({ disabled }) => {
    return disabled ? palette.Grey500 : palette.Grey600;
  }};
  font-weight: 500;
  font-size: 1.25rem;
`;

const RootContainer = styled.div`
  padding: ${({ isSearchMode }) => {
    return isSearchMode ? '0.5rem 0.75rem' : '1rem';
  }};
  borderbottom: 1px solid ${palette.Grey300};
`;

const JobCardTitle = ({ workOrderOp, active }) => {
  const { isSearchMode } = useSelector(getSelectWorkOrderOpOptions);

  const part1 = `${workOrderOp?.workOrderId}`;
  const part2 = `${workOrderOp?.workOrder?.partNumber} Op ${workOrderOp?.sequenceNumber}`;

  const searchHeaderText =
    workOrderOp && workOrderOp?.workOrder
      ? isSearchMode
        ? `${part1} | ${part2}`
        : part1
      : 'Unknown';

  const searchSubheaderText =
    workOrderOp && workOrderOp?.workOrder ? part2 : 'Unknown';

  const TitleComponent = isSearchMode
    ? SearchJobCardTitle
    : StandardJobCardTitle;

  return (
    <RootContainer isSearchMode={isSearchMode}>
      <TitleComponent disabled={active} isSearchMode={isSearchMode}>
        {active && (
          <SpinningIcon icon={farSyncAlt} style={{ marginRight: '.5rem' }} />
        )}
        {searchHeaderText}
      </TitleComponent>
      {!isSearchMode && (
        <JobCardSubTitle disabled={active}>
          {searchSubheaderText}
        </JobCardSubTitle>
      )}
    </RootContainer>
  );
};

JobCardTitle.propTypes = {
  workOrderOp: PropTypes.object,
  active: PropTypes.bool,
};

export default JobCardTitle;
